const source = 'Trnsact Portal';

const page = (name, properties) => window.analytics?.page(name, { source, ...properties });

const track = (event, properties) => window.analytics?.track(event, { source, ...properties });

export default { page, track };
